jQuery(document).ready(function(){	
	
	var x = window.matchMedia("(max-width: 720px)")
	mobile_slider(x) // Call listener function at run time
	x.addListener(mobile_slider) // Attach listener function on state changes
		
});

function mobile_slider(x) {

	if (x.matches) {
		
		jQuery( '.pull-quotes' ).slick({
			infinite: true,
			slidesToShow: 1,
			arrows: true,
			autoplay: false,
			dots: true,
			prevArrow:'<button type="button" class="slick-prev"><h6><span class="icon-left"></span></h6></button>',
			nextArrow:'<button type="button" class="slick-next"><h6><span class="icon-right"></span></h6></button>',
			adaptiveHeight: true
					  	  
		});

 
 	} 

}